import { STORAGEURL } from "../..";

const Lokalita = ({ lokalita }) => {
    return (
        <>
            <a href={lokalita.link} target="_blank" rel="noopener noreferrer">
                {lokalita.logo?.length ? (
                    <img
                        className="logo"
                        src={STORAGEURL + lokalita.logo}
                        alt={lokalita.alt}
                    />
                ) : (
                    <span className="logo-text">{lokalita.alt}</span>
                )}
            </a>
        </>
    );
};

export default Lokalita;